// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";
import { APP_BAR_HEIGHT } from "metabase/nav/constants";

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  // position: absolute;
  // background-color: red;
`;

export const AppContentContainer = styled.div<{
  isAdminApp: boolean;
}>`
  flex-grow: 1;
  display: flex;
  // background-color: red;
  // flex-direction: column;
  flex-direction: ${(props) => (props.isAdminApp ? "column" : "row")};
  position: relative;
  overflow: hidden;
  background-color: ${(props) =>
    props.isAdminApp ? color("admin-background") : color("content")};

  @media print {
    height: 100%;
    overflow: visible !important;
  }
`;

export const AppContent = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  @media print {
    overflow: visible !important;
  }
`;


export const ScrollableContent = styled.div`
  flex: 1;
  overflow: auto;
`;
